var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$slots.default)?_c('div',{staticClass:"children-container"},[_c('p',[_vm._v("The content of children is:")]),_vm._t("default")],2):_c('div',{attrs:{"className":"empty"}},[_vm._v("empty")])}
var staticRenderFns = []

export { render, staticRenderFns }